import { render, staticRenderFns } from "./ModalEditCategory.vue?vue&type=template&id=80435fda&scoped=true&"
import script from "./ModalEditCategory.vue?vue&type=script&lang=js&"
export * from "./ModalEditCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditCategory.vue?vue&type=style&index=0&id=80435fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80435fda",
  null
  
)

export default component.exports